module.exports = __webpack_public_path__ + "4676be687b250948ac0d436a0a3de67c.fbx";